<template>
  <q-toggle
    :model-value="modelValue"
    @update:model-value="onToggle"
    :label="label"
    :color="color"
    :true-value="trueValue"
    :false-value="falseValue"
    :disable="disable"
  />
</template>

<script setup>

const props = defineProps({
  modelValue: {
    type: [Boolean, String, Number],
    required: true
  },
  label: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: 'primary'
  },
  trueValue: {
    type: [Boolean, String, Number],
    default: true
  },
  falseValue: {
    type: [Boolean, String, Number],
    default: false
  },
  disable: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

function onToggle(val) {
  emit('update:modelValue', val)
}
</script>
